export default __webpack_public_path__ + "static/media/P_20180621_200308.220f735d.jpg";